import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router/index'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import { store } from './store'
import JsonExcel from 'vue-json-excel'
import babelPolyfill from 'babel-polyfill'
import VueHtml2Canvas from 'vue-html2canvas'
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Importar los estilos de Vuetify
import '@mdi/font/css/materialdesignicons.css' // Importar los íconos de Material Design Icons
import VueSweetalert2 from 'vue-sweetalert2'
import './assets/scss/style.scss';
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css';

// Registrar componentes globales
import VueElementLoading from 'vue-element-loading'
import avisoModal from './componentes/Modal/ModalAviso'
import pantallaCarga from './componentes/ImgLoading/loading.vue'
import VueRecaptcha from 'vue-recaptcha'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(VueMaterial)

Vue.component('ElementLoading', VueElementLoading)
Vue.component('downloadExcel', JsonExcel)
Vue.component('app-modal', avisoModal)
Vue.component('app-loading', pantallaCarga)
Vue.component('vueRecaptcha', VueRecaptcha)

// Usar plugins
Vue.use(CoreuiVue)
Vue.use(VModal)
Vue.use(VueHtml2Canvas)
Vue.use(VueSweetalert2)
Vue.use(Vuetify)

// Configuración global
Vue.config.performance = true
Vue.prototype.$log = console.log.bind(console)

// Crear instancia de Vuetify
const vuetify = new Vuetify({
    theme: {
      dark: false, // Asegúrate de que sea 'false' para usar el tema claro
      themes: {
        light: {
          primary: "#003366",
          success: "#28a745",
          info: "#17a2b8",
        },
      },
    },
    icons: {
      iconfont: 'mdi', // Habilitar Material Design Icons
    },
  });

// Inicializar la aplicación
new Vue({
  el: '#app',
  router,
  store,
  icons,
  vuetify, // Registrar Vuetify aquí
  Vuesax,
  render: (h) => h(App), // Usar render en lugar de template
})
